import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/project/documents")({
  component: ProjectDocumentsRoute,
});

function ProjectDocumentsRoute() {
  return <Outlet />;
}
